import { ModuleWithProviders, NgModule } from '@angular/core';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NDfModuleImage } from './df-module-image.interface';
import { ImageDirective } from './image.directive';
import { oldProviders } from './image.providers';

@NgModule({
    imports: [ImageDirective],
    exports: [ImageDirective]
})
export class ImageModule {
    static forRoot(config?: DeepPartial<NDfModuleImage.IModuleOptions>): ModuleWithProviders<ImageModule> {
        return {
            ngModule: ImageModule,
            providers: oldProviders(config)
        };
    }
}
